import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Accessibility } from '@freelancer/accessibility';

@Component({
  standalone: false,
  selector: 'webapp-compat-accessibility',
  template: ` <ng-container /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompatAccessibilityComponent implements OnInit {
  private accessibility = inject(Accessibility);

  ngOnInit(): void {
    const w = window as any;

    w.webappCompatAccessibility = {
      getAccessibilityWidget: () => {
        this.accessibility.openUserWayWidget();
      },
    };
  }
}
